import { createFileRoute } from "@tanstack/react-router"
import { AiAvatarPageWrapper } from "./-AiAvatarPage"

export const Route = createFileRoute("/tools/ai-avatar")({
  component: AiAvatarPageWrapper,
})
